import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WaterfallChartIcon(props: IconProps) {
    return <Icon {...props} iconKey={"waterfall_chart"}/>
}
